module.exports = __webpack_public_path__ + "img/ayun-ab.c200bf23.svg";